import { useCallback, useState } from 'react';
import { showPremiumModal } from '@components/features/modals/premium/PremiumModal';
import { GenericV1ErrorsArray } from '@type/v1-api-types';
import { baseURL } from '@root/src/utils';
import { useSwrUserUnlockView } from '@hooks/useSwrApi/endpoints/resume-operations/useSwrUserUnlockView';

export function useResumeAccessCheck(locale: Locale, slug?: string) {
  const [isChecking, setIsChecking] = useState(false);
  const [isAllowed, setIsAllowed] = useState(false);
  const apiURL = baseURL;


  const {
    trigger: triggerPayPerView,
  } = useSwrUserUnlockView({
    slug: slug ?? '',
    locale,
    successCallback: () => {
      setIsAllowed(true);
    },
    errorCallback: () => {
    },
  });

  const onPayPerViewCallback = useCallback(() => {
    void triggerPayPerView();
  }, [triggerPayPerView]);

  const check = useCallback(async (userSlug: string) => {
    setIsChecking(true);
    setIsAllowed(false);

    try {
      const response = await fetch(`${apiURL}/v1/resume-operation/can-view-resume/${userSlug}`, {
        method: 'POST',
        headers: {
          'Accept-Language': locale,
          'Content-Type': 'application/json',
        },
        credentials: 'include',
        body: JSON.stringify({
          userSlug,
        }),
      });

      if (response?.ok) {
        setIsAllowed(true);
        return true;
      }

      const responseContentType = response.headers.get('content-type') ?? '';
      if (!responseContentType.includes('application/json')) {
        setIsAllowed(false);
        return false;
      }

      const errorJson = (await response.json()) as GenericV1ErrorsArray;
      const code = errorJson?.errors?.[0]?.code;
      if (code === 805) {
        showPremiumModal(locale, '', 805, onPayPerViewCallback);
      }
      if (code === 804) {
        showPremiumModal(locale, '', 804, onPayPerViewCallback);
      }
      setIsAllowed(false);
      return false;
    } catch {
      setIsAllowed(false);
      return false;
    } finally {
      setIsChecking(false);
    }
  }, [locale, apiURL, onPayPerViewCallback]);

  return { isChecking, isAllowed, check };
}
